<template>
  <footer class="footer">
     



    <!-- <div class="container-fluid">
      <nav class="pull-left">

        <ul>
          <li>
            <button @click="$router.push('/pages/release')" class="bt-help">Notas de Versão</button>
          </li>
          <li>

            <button @click="$tours['myTour'].start()" class="bt-help">Help</button>
          </li>
          <li>
            <a href="http://www.semeq.com">
              Semeq
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright pull-right">        
        <span @click="setLang('pt')"><img src="static/flags/BR.png"/></span>
        <span @click="setLang('en')"><img src="static/flags/US.png"/></span>
        <span @click="setLang('es')"><img src="static/flags/ES.png"/></span>
      </div>
    </div> -->



       
  </footer>
</template>
<script>
  export default {
    methods: {
      setLang (lang) {
        this.$store.dispatch('setLang', lang)
      },
      loadLocaleMessage: function (locale, cb) {
        console.log('locale', locale)
        return fetch(`./src/lang/${locale}.json`, {
          method: 'get',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          console.log('success')
          return res.json()
        }).then((json) => {
          if (Object.keys(json).length === 0) {
            return Promise.reject(new Error('locale empty !!'))
          } else {
            return Promise.resolve(json)
          }
        }).then((message) => {
          cb(null, message)
        }).catch((error) => {
          cb(error)
        })
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue